import RenameSeedAudienceModal from './RenameSeedAudienceModal.Container';

export default RenameSeedAudienceModal;
